import { render, staticRenderFns } from "./infos2.vue?vue&type=template&id=13038d85&scoped=true&"
import script from "./infos2.vue?vue&type=script&lang=js&"
export * from "./infos2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13038d85",
  null
  
)

export default component.exports